var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { CurrentOrderService } from './../order/currentOrder.service';
import { Component, ViewEncapsulation } from '@angular/core';
var ContentComponent = (function () {
    function ContentComponent(currentOrderService) {
        this.currentOrderService = currentOrderService;
        document.getElementsByTagName('body')[0].className = 'fixed-sidebar';
        this.currentYear = new Date().getFullYear();
    }
    ContentComponent.prototype.resetOrder = function () {
        this.currentOrderService.resetOrder();
    };
    ContentComponent = __decorate([
        Component({
            selector: 'cx-content',
            templateUrl: './common/content.component.html',
            encapsulation: ViewEncapsulation.None
        }),
        __metadata("design:paramtypes", [CurrentOrderService])
    ], ContentComponent);
    return ContentComponent;
}());
export { ContentComponent };
//# sourceMappingURL=content.component.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/components/content.component.js
// module id = 263
// module chunks = 0